import cx from 'classnames'
import { useRef, useEffect, useCallback, useState, useReducer, useContext } from 'react'
import { Transforms } from 'slate'
import { ReactEditor, useReadOnly, useSlateStatic } from 'slate-react'

import { PermissionsContext } from '../context'

import styles from './checkbox.module.css'

export function Checkbox ({ attributes, children, element }) {
  const editor = useSlateStatic()
  const isReadOnly = useReadOnly()
  const [ isChecked, setIsChecked ] = useState(element.isChecked ?? false)
  const inputRef = useRef(null)
  const { canEdit } = useContext(PermissionsContext)

  const [ , forceUpdate ] = useReducer(x => x + 1, 0)

  const toggleCheckbox = useCallback(event => {
    event.preventDefault()

    if (!canEdit || isReadOnly) {
      return
    }
    setIsChecked(!isChecked)
  }, [ canEdit, isReadOnly, isChecked ])

  // This is a hack to force the checkbox to update when the value changes.
  // Without this, for some reason, the checkbox is not always updated when
  // clicked ¯\_(ツ)_/¯
  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      forceUpdate()
    })

    return () => {
      cancelAnimationFrame(frame)
    }
  }, [ isChecked ])

  useEffect(() => {
    Transforms.setNodes(
      editor,
      {
        isChecked
      },
      {
        at: ReactEditor.findPath(editor, element)
      }
    )
  }, [ editor, element, isChecked ])

  return (
    <span
      {...attributes}
      style={{
        ...attributes.style,
        padding: '0.4rem 0.6rem 0.4rem 0.4rem'
      }}
      className='bg-[#f6f6f6] rounded-md'
    >
      <span
        contentEditable={false}
        className='align-middle'
      >
        <input
          className={cx(styles.checkbox, 'border-2 border-gray-500 checked:border-primary')}
          ref={inputRef}
          type='checkbox'
          checked={isChecked}
          onChange={toggleCheckbox}
        />
      </span>
      <span
        style={{ cursor: 'text', marginLeft: '0.2rem' }}
        contentEditable={!isReadOnly}
        suppressContentEditableWarning
      >
        {children}
      </span>
    </span>
  )
}
